// extracted by mini-css-extract-plugin
module.exports = {"visually_hidden":"CallToAction_visually_hidden__gLEft","cta_button":"CallToAction_cta_button__IRTPV"};